import { useState } from "react";
import { ChatConversation } from "./ChatConversation";
import { useTranslation } from "react-i18next";

type ChatMode = "none" | "device-to-server" | "server-to-device";

export function ChatWindow({ onClose }: { onClose: () => void }) {
    const { t } = useTranslation();
    const [chatMode, setChatMode] = useState<ChatMode>("none");
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={`ai-chat ${expanded ? "expanded" : ""}`}>
            {/* Header */}
            <div className="ai-header">
                <span>{t("AI.TITLE")}</span>
                {/* <button className="ai-close-btn" onClick={onClose}>
                    ✕
                </button> */}

                <div className="ai-header-actions">
                    <button
                        onClick={() => setExpanded(e => !e)}
                        title={expanded ? t("AI.COLLAPSE") : t("AI.EXPAND")}
                    >
                        {expanded ? "🗗" : "🗖"}
                    </button>

                    <button onClick={onClose}>✕</button>
                </div>
            </div>

            {/* Body */}
            {chatMode === "none" ? (
                <ModeSelector onSelect={setChatMode} />
            ) : (
                <ChatConversation
                    mode={chatMode}
                    onBack={() => setChatMode("none")}
                />
            )}
        </div>
    );
}

function ModeSelector({
    onSelect
}: {
    onSelect: (mode: ChatMode) => void;
}) {
    const { t } = useTranslation();
    return (
        <div className="ai-mode-selector">
            <h3>{t("AI.HOW_CAN_I_HELP")}</h3>

            <div className="ai-mode-list">
                <button
                    className="ai-mode-card"
                    onClick={() => onSelect("device-to-server")}
                >
                    <div className="ai-mode-title">
                        {t("AI.NEED_ANALYZER_HELP")}
                    </div>
                    <div className="ai-mode-desc">
                        {t("AI.MODE.DEVICE_TO_SERVER")}
                    </div>
                </button>

                <button
                    className="ai-mode-card"
                    onClick={() => onSelect("server-to-device")}
                >
                    <div className="ai-mode-title">
                        {t("AI.NEED_ANALYZER_HELP")}
                    </div>
                    <div className="ai-mode-desc">
                        {t("AI.MODE.SERVER_TO_DEVICE")}
                    </div>
                </button>
            </div>
        </div>
    );
}
